import React from 'react'
import IInput from './IInput'
import LabeledFormInput from './LabeledFormInput'
import TwoColumnFormInput from './TwoColumnFormInput'

interface IGeneratedFormProps {
  inputs: IInput[]
  inTwoColumn?: boolean
  onChange?: (id: string, value: string | number | null) => void
  onEntered?: (id: string, value: string | number | null) => void
}

const GeneratedFrom: React.FC<IGeneratedFormProps> = ({
  inputs,
  inTwoColumn,
  onChange,
  onEntered,
}) => {
  return (
    <div>
      {inTwoColumn
        ? inputs.map((input) => (
            <TwoColumnFormInput
              key={input.id}
              input={input}
              onChange={onChange}
              onEntered={onEntered}
            />
          ))
        : inputs.map((input) => (
            <LabeledFormInput
              key={input.id}
              input={input}
              onChange={onChange}
              onEntered={onEntered}
            />
          ))}
    </div>
  )
}
export default GeneratedFrom
